import { z } from 'zod';

export const lotSizingSchema = z.object({
  contenantType: z.string().min(1, 'this value should not be null'),
  containerSelection: z.string().min(1, 'this value should not be null'),
  volumeMaximum: z.number().min(1, 'this value should be positive'),
});

export type LotSizingFormValues = z.infer<typeof lotSizingSchema>;
